<dsp-content-card [header]="false">
  <div dsp-content>
    <div class="row">
      <div class="columns">
        <div class="dsp-help-and-contacts-tabs dsp-tabs-margin">
          <atlas-tab-group class="help-contacts" [ngClass]="{ 'dsp-mobile-tabs' : (isMobile$ | async) }"
            (selectedIndexChange)="onChangeTab($event)">
            <atlas-tab *ngFor="let tab of tabs$ | async">
              <ng-template atlas-tab-label>
                <span>{{ tab.name }}</span>
              </ng-template>
            </atlas-tab>
          </atlas-tab-group>
        </div>
      </div>
    </div>
    <div class="row mos-u-spacer--margin-top-xlg">
      <div class="columns">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</dsp-content-card>